import { Box } from '@mui/material'
import { backgroundColors } from '../Components/Common/Color/Color'
import UserGuide from '../Components/UserGuide'
import { selectUserRole } from '../redux/auth/selector'
import { useAppSelector } from '../redux/store'

const UserGuidePage = () => {
  const userRole = useAppSelector(selectUserRole)

  return (
    <>
      <Box
        component='div'
        sx={{
          p: 0,
          backgroundColor: backgroundColors.white,
          width: 'auto',
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <UserGuide role={userRole} />
      </Box>
    </>
  )
}

export default UserGuidePage
